import React, { HTMLInputTypeAttribute, memo } from "react";

interface TextField {
  id?: string;
  name?: string;
  type?: HTMLInputTypeAttribute;
  defaultValue?: string;
  value?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onkeypress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  placeholder?: string;
  error?: boolean;
  className?: string;
  isReadOnly?: boolean;
  isRequired?: boolean;
  inputMode?: NonNullable<JSX.IntrinsicElements["input"]["inputMode"]>;
  autoComplete?: string;
  ariaLabelledby?: string;
}

const TextFieldBase = (props: TextField) => {
  // エラー時のスタイル
  const errorClassNames = props.error ? "border-accent" : "border-theme-medium";

  return (
    <>
      <input
        className={["w-full h-11", props.className, errorClassNames].join(" ")}
        id={props.id}
        name={props.name}
        type={props.type ?? "text"}
        value={props.value}
        defaultValue={props.defaultValue}
        onBlur={props.onBlur}
        onChange={props.onChange}
        placeholder={props.placeholder}
        readOnly={props.isReadOnly}
        aria-labelledby={props.ariaLabelledby}
        autoComplete={props.autoComplete}
        inputMode={props.inputMode}
      />
    </>
  );
};

export const TextField = memo(TextFieldBase);
